export default function PageHero({ eyebrow, title, subtitle, image, light = false }) {
  return (
    <section data-testid="page-hero" className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden bg-[#0a0a0a] text-white">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/60 via-[#0a0a0a]/70 to-[#0a0a0a]" />
        </>
      )}
      <div className="grid-bg absolute inset-0 opacity-50" />
      <div className="container-wide relative">
        {eyebrow && <div className="eyebrow eyebrow-light mb-8">{eyebrow}</div>}
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.92] tracking-[-0.035em] max-w-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/75 text-lg md:text-xl max-w-3xl mt-8 leading-relaxed font-light">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
